import { render, staticRenderFns } from "./SubmitDialog.vue?vue&type=template&id=eea9f68a&"
import script from "./SubmitDialog.vue?vue&type=script&lang=js&"
export * from "./SubmitDialog.vue?vue&type=script&lang=js&"
import style0 from "./SubmitDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports